import {Tag} from 'antd'
import {Select} from '@/components/Form'
import dict from '@/script/dict.mjs'
import useChoose from '@/hooks/useChoose.jsx'
import {useProjects} from './index.mjs'

const useDataSource = () => {
    const result = useProjects({prjStsCodes: 'RLS', prjTarget: 'all'})

    if (result.data) {
        for (const p of result.data) {
            p.sVer = p.prjBaseLines[0]?.sVer ?? p.sVer
        }
    }

    return result
}

const columns = [
    {
        title: '项目编号',
        dataIndex: 'prjNo',
        dataType: 'text',
    },
    {
        title: '项目名称',
        dataIndex: 'prjName',
        dataType: 'text',
    },
    {
        title: '分支号',
        dataIndex: 'sVer',
        dataType: 'number',

        component: (_1, row, _2, table) => {
            const {pkid, prjBaseLines, sVer} = row

            const onChange = sVer => {
                table.updateRows([[pkid, {sVer}]])
            }

            return (
                <Select
                    getOptionKey={e => e.sVer}
                    getOptionLabel={e => `[${e.sVer}]${e.pblName}`}
                    options={prjBaseLines}
                    keyAsValue
                    size="small"
                    value={sVer}
                    onChange={onChange}
                />
            )
        },
    },
    {
        title: '项目类型',
        dataIndex: 'prjTypeCode',
        dataType: 'text',

        getValue: row => (
            dict.getDictDtl('PRJ_TYPE', row.prjTypeCode)?.nameCn ??
            row.prjTypeCode
        ),
    },
    {
        title: '项目所有者',
        key: 'owner',
        dataType: 'text',

        getValue: ({prjOwnerTypeCode, crtName, teamName}) => ({
            USER: `[个人]${crtName}`,
            TEAM: `[团队]${teamName}`,
        })[prjOwnerTypeCode],

        component: (_, {prjOwnerTypeCode, crtName, teamName}) => ({
            USER: <><Tag color="yellow">个人</Tag>{crtName}</>,
            TEAM: <><Tag color="blue">团队</Tag>{teamName}</>,
        })[prjOwnerTypeCode]
    },
]

export const useChooseProject = props => useChoose({
    columns,
    rowKey: 'pkid',
    title: '选择项目',
    useDataSource,
    width: 800,
    ...props,
})
